import { render, staticRenderFns } from "./IconPickerComponent.vue?vue&type=template&id=7777571a&scoped=true"
import script from "./IconPickerComponent.js?vue&type=script&lang=js&external"
export * from "./IconPickerComponent.js?vue&type=script&lang=js&external"
import style0 from "./IconPickerComponent.vue?vue&type=style&index=0&id=7777571a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7777571a",
  null
  
)

export default component.exports